<div class="loader-container">
    <app-loader *ngIf="loading == true"></app-loader>
    <app-modal-header [title]="modalTitle"></app-modal-header>
    <div class="modal-body">
        <div *ngIf="errorMessage" class="alert alert-danger d-flex align-items-center" role="alert">
            <div>
                {{errorMessage}}
            </div>
        </div>

        <!-- <div class="col-span-12 md:col-span-6">
            <div class="mb-3">
                <label class="form-label">Code</label>
                <input [ngClass]="{'is-invalid': errors['code']}" type="text" [(ngModel)]="item['code']"
                    class="form-control">
            </div>
        </div> -->

        <div class="col-span-12 md:col-span-6">
            <div class="mb-3">
                <label class="form-label">Periode</label>
                <select [ngClass]="{'is-invalid': errors['period_id']}" class="form-control" [(ngModel)]="item['period_id']">
                    <ng-container *ngFor="let period of periods">
                        <option [value]="period['id']">
                            {{period['name']}}
                        </option>
                    </ng-container>
                </select>
            </div>
        </div>

        <div class="col-span-12 md:col-span-6">
            <div class="mb-3">
                <label class="form-label">Aantal</label>
                <input [ngClass]="{'is-invalid': errors['quantity']}" type="number" [(ngModel)]="item['quantity']"
                    class="form-control">
            </div>
        </div>

        <div class="col-span-12 md:col-span-6">
            <div class="mb-3">
                <label class="form-label">Methode</label>
                <select [ngClass]="{'is-invalid': errors['section_id']}" (change)="getCourseSections()" class="form-control" [(ngModel)]="item['course_id']">
                    <ng-container *ngFor="let course of courses">
                        <option [value]="course['id']">
                            {{course['title']}}
                        </option>
                    </ng-container>
                </select>
            </div>
        </div>

        <div class="col-span-12 md:col-span-6">
            <div class="mb-3">
                <label class="form-label">Vak</label>
                <select [ngClass]="{'is-invalid': errors['course_id']}" [disabled]="!item['course_id']" (change)="setChapters(item['section_id'])" class="form-control" [(ngModel)]="item['section_id']">
                    <ng-container *ngFor="let courseSection of courseSections">
                        <option [value]="courseSection['id']">
                            {{courseSection['title']}}
                        </option>
                    </ng-container>
                </select>
            </div>
        </div>

        <div class="col-span-12 md:col-span-6">
            <div class="mb-3">
                <label class="form-label">Module</label>
                <select [ngClass]="{'is-invalid': errors['chapter_id']}" [disabled]="!item['section_id']" class="form-control" [(ngModel)]="item['chapter_id']">
                    <ng-container *ngFor="let chapter of chapters">
                        <option [value]="chapter['id']">
                            {{chapter['title']}}
                        </option>
                    </ng-container>
                </select>
            </div>
        </div>

        <div class="form-buttons">
            <button type="button" class="btn btn-primary" (click)="save()">Opslaan</button>
        </div>
    </div>
</div>